import React, { Component } from "react"

class SubnavigationItem extends Component {
  static defaultProps = {}

  constructor(props) {
    super(props)
  }

  render() {
    const { itemData, key } = this.props

    return (
      <a href={itemData.linkUrl} className="button inner">
        <div className="icon">
          <svg className="svg-icon svg-icon--taxi">
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={"/dist/svg/symbols.svg#svg-" + itemData.icon}>
              &nbsp;
            </use>
          </svg>
        </div>
        <h2 className="headline">{itemData.heading}</h2>
        <div className="text">{itemData.subheading}</div>
      </a>
    )
  }
}

export default SubnavigationItem
